import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';

import { AccountStage } from '@provider-portal/common/services/types/account';
import { addNewMerchantVenueRoute, defaultRoute, onboardingRoute } from 'AppRoutes';

import { selectAccountStage } from 'rdx/account';

export const AccessControl: React.FC = memo(({ children }) => {
  const accountStage = useSelector(selectAccountStage);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (accountStage === AccountStage.ONBOARDING && !location.pathname.match(onboardingRoute)) {
      history.push(onboardingRoute);
      return;
    }

    if (
      accountStage === AccountStage.ACTIVATED &&
      location.pathname.match(onboardingRoute) &&
      !location.pathname.match(addNewMerchantVenueRoute)
    ) {
      history.push(defaultRoute);
    }
  }, [accountStage, history, location.pathname]);

  return <>{children}</>;
});
